// ChatToggle.js
import React, { useState, useEffect } from 'react';
import { Box, Grid, Text } from "@chakra-ui/react";
import HeaderMenus from './HeaderMenus';

const ChatToggle = ({ contextType, contextData, contextPersona, firstMessage = null, 
useOptions = false,
maintainContext = false,
contextMode = 'popup',
toggleState = false, // New prop to toggle the chat
messageToSend = null, // New prop for the message content
triggerSubmit = false, // New prop to trigger message submission
}) => {
  const [isChatOpen, setIsChatOpen] = useState(toggleState);


  return (
    <>

    </>
  );
};

export default ChatToggle;